export const PUBLIC_URL_PREFIXES = ['/public'] as const;

const primaryPublicPrefix = PUBLIC_URL_PREFIXES[0];

export const PUBLIC_ROUTES = {
  unusualOperationsLine: `${primaryPublicPrefix}/operaciones-inusuales`,
  publicComplaint: `${primaryPublicPrefix}/denuncias`,
} as const;

/** Un `Route` por prefijo: 404 dentro de esa zona pública. */
export const PUBLIC_ZONE_FALLBACK_GLOBS = PUBLIC_URL_PREFIXES.map(
  (prefix) => `${prefix}/*`,
);
